import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What is a local business database?',
  answer: 'A local business database is a comprehensive directory of local small businesses, including their contact information, firmographics, and key personnel. Our platform provides verified local business listings and acts as a local business owner finder to help you connect with decision-makers.'
}, {
  question: 'How do I find local business owner emails?',
  answer: 'You can use our local business owner finder to search for specific industries or locations. Once you identify your target local small businesses, you can unlock verified business owner emails directly within the platform.'
}, {
  question: 'What local business listings are available?',
  answer: 'We offer local business listings across 300+ categories, from accounting and healthcare to home services and retail. Each listing includes 50+ data points such as company size, revenue estimates, tech stack, and verified contact information.'
}, {
  question: 'Can I search for local small businesses by category?',
  answer: 'Yes, our directory allows you to browse local small businesses by category or search for specific niches. You can filter your search by location, employee count, revenue, and more to build the perfect list.'
}, {
  question: 'How accurate are the business owner emails?',
  answer: 'Every business owner email is verified in real-time before you export or sequence them. We check for deliverability, catch-all status, and bounce risks to ensure your outreach campaigns maintain a high sender reputation.'
}, {
  question: 'Can I export local business contacts?',
  answer: 'Absolutely. You can export your local businesses list to a CSV file or sync it directly to your CRM (like Salesforce or HubSpot). Alternatively, you can use our built-in email sequencing to contact them without leaving the platform.'
}];
export function DataDirectoryFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-720">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16" data-id="element-721">
        <div className="max-w-3xl mx-auto" data-id="element-722">
          <div className="text-center mb-12" data-id="element-723">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-724">
              Frequently asked questions
            </h2>
          </div>

          <div className="space-y-4" data-id="element-725">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={index} className="bg-slate-50 border border-slate-100 rounded-3xl overflow-hidden transition-all hover:border-blue-100" data-id="element-726">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-8 py-6 flex justify-between items-center focus:outline-none" data-id="element-727">
                    <span className="text-lg font-bold text-slate-900 pr-8 tracking-tight" data-id="element-728">
                      {faq.question}
                    </span>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-blue-100 text-blue-600' : 'bg-white text-slate-400 border border-slate-200'}`} data-id="element-729">
                      <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-730" />
                    </div>
                  </button>
                  <AnimatePresence data-id="element-731">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-732">
                        <div className="px-8 pb-6 text-slate-500 leading-relaxed" data-id="element-733">
                          {faq.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}